module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"journalNotFound":"Journal Not Found","sharedJournalNotFound":"The shared journal was not found. Try with another link.","goToDashboard":"Go to dashboard"},"es":{"journalNotFound":"La bitácora no fue encontrada","sharedJournalNotFound":"La bitácora compartida no fue encontrada. Intenta con otro link.","goToDashboard":"Ir al dashboard"}}')
  delete Component.options._Ctor
}
